import {
    buildLogoutURL,
    clearAuthArtifacts,
    POST_LOGOUT_REDIRECT_URI,
} from '../../utils/oidcTokenStorage';
import { useAuthStore } from '../../authStore';
import { getStore } from '../../store';
import { wsDisconnect } from '../../common/actions/websocketActions';
import { PATHS } from '../paths';
import { showSigningOut } from '../signingOutOverlay';

const navigateAway = (url) => {
    if (navigator.onLine) {
        window.location.replace(url);
        return;
    }
    showSigningOut();
    window.addEventListener('online', () => window.location.replace(url), { once: true });
};

const teardownSession = (returnTo) => {
    let logoutURL;
    try {
        logoutURL = buildLogoutURL(returnTo);
    } catch (e) {
        console.error('Failed to build logout URL:', e);
    }

    try {
        getStore()?.dispatch(wsDisconnect());
    } catch (e) {}

    try {
        clearAuthArtifacts();
    } catch (e) {
        console.error('Failed to clear auth artifacts:', e);
    }
    try {
        useAuthStore.getState().logout();
    } catch (e) {}

    return logoutURL;
};

export const logoutLoader = () => {
    const logoutURL = teardownSession();
    navigateAway(logoutURL || PATHS.SIGNED_OUT);
    return null;
};

export const unauthLogoutLoader = () => {
    const logoutURL = teardownSession(
        `${POST_LOGOUT_REDIRECT_URI()}?reason=unauthorized`,
    );
    navigateAway(logoutURL || `${PATHS.SIGNED_OUT}?reason=unauthorized`);
    return null;
};

export { teardownSession };
